
<form [formGroup]="addUpdateForm" #addUpdateNgForm="ngForm">
  <input autocomplete="false" name="hidden" type="text" style="display:none;">
  <div class="infoFormDv">
    <i class="fa fa-times closeInfoDv" aria-hidden="true" (click)="closeDialog()"></i>
    <div *ngIf="!openFormTwo">
      <div class="HeadingDv">
        <h2>Reason Declined</h2>
      </div>
      <div class="ForminputDv">
        <div class="CheckDv">
          <span [class.activeDv]="openOne" (click)="valueChangedOne()"></span>
          <h3>Weather</h3>
        </div>
      </div>
      <div class="ForminputDv">
        <div class="CheckDv">
          <span [class.activeDv]="openTwo" (click)="valueChangedTwo()"></span>
          <h3>Internal Maintenance</h3>
        </div>
      </div>
      <div class="ForminputDv">
        <div class="CheckDv">
          <span [class.activeDv]="openThree" (click)="valueChangedThree()"></span>
          <h3>Safety Concerns</h3>
        </div>
      </div>
      <div class="ForminputDv">
        <div class="CheckDv">
          <span [class.activeDv]="openFour" (click)="valueChangedFour()"></span>
          <h3>Other</h3>
        </div>
      </div>
      <div class="TextAreaInputDv" *ngIf="openFour">
        <div class="item">
          <textarea formControlName="reason" id="EnterYourCustomDeclinedReason" name="EnterYourCustomDeclinedReason" placeholder="Enter your custom declined reason"></textarea>
        </div>
      </div>
      <div class="btnDv">
        <a (click)="onSubmitForm()">Submit</a>
      </div>
    </div>
    <div *ngIf="openFormTwo">
      <div class="HeadingTwoDv">
        <h2>Recommended For You</h2>
      </div>
      <div class="ParagraphDv">
        <p>Do you want to pause this service <br> so customers can't book it?</p>
      </div>
      <div class="btnDv SeconDV">
        <a (click)="updateForm()">Yes</a>
        <a (click)="closeForm()">No</a>
      </div>
    </div>
  </div>
</form>
